<template>
  <v-container class="top-pc">
    <!-- #LIVE -->
    <v-row justify="center" id="live">
      <v-col cols="7">
        <p class="top-pc__live--title-text">
          東京のど真ん中で、<span class="top-pc__live--under-line">日本初<div class="top-pc__live--title-text-attention">※</div>のサンゴ人工産卵</span>に挑戦中！
        </p>
        <p class="top-pc__live--youtube-attention">
          ※完全閉鎖系の人工環境下でのサンゴ産卵において
        </p>
      </v-col>
      <v-col cols="7">
        <iframe class="top-pc__live--youtube" src="https://www.youtube.com/embed/live_stream?channel=UCFvPsTDi0YlI8nDvdmglM_Q&autoplay=1" frameborder="0" allowfullscreen autoplay></iframe>
      </v-col>
      <v-col cols="7">
        <p class="top-pc__live--sub-title-text">
          <span class="top-pc__live--under-line">#サンゴ産卵の予感</span>を見つけたら、ボタンを押して教えてください！
        </p>
      </v-col>
      <v-col cols="7">
        <p class="top-pc__live--checking-text">
          サンゴが産卵する可能性のある19:00〜24:00の間、<br>下記のボタンが点灯します。
        </p>
      </v-col>
      <v-col cols="7" class="text-center">
        <v-row>
          <v-col cols="6">
            <v-btn
              fab
              dark
              width="220px"
              height="220px"
              color="#8E8E8E"
            >
              <div class="top-pc__live--tweet-button">
                タマゴ
                <br>
                発見！
              </div>
            </v-btn>
          </v-col>
          <v-col cols="6">
            <v-btn
              fab
              dark
              width="220px"
              height="220px"
              color="#8E8E8E"
            >
              <div class="top-pc__live--tweet-button">
                タマゴ
                <br>
                未確認！
              </div>
            </v-btn>
          </v-col>
        </v-row>
        <v-row class="top-pc__live--tweet-description">
          <v-col cols="6">
            <p>タマゴを発見できたらこちら！</p>
          </v-col>
          <v-col cols="6">
            <p>タマゴが見つからなかったらこちら！</p>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <TopDescription/>

  </v-container>
</template>

<script>
import TopDescription from './TopDescription'

export default {
  name: 'Top',
  data: () => ({
  }),
  components: {
    TopDescription
  },
  methods: {

  }
}
</script>

<style lang="scss" scoped>
.container {
  margin: 0px;
  max-width: none;
}
.top-pc {
  background: $color-primary;
}
// PC LIVE
.top-pc__live--title-text {
  font-size: 1.8vw;
  font-weight: bold;
  letter-spacing: 3px;
  text-align: center;
  margin-top: 100px;
}
.top-pc__live--title-text-attention {
  display: inline;
  vertical-align: top;
  font-size: 1vw;
  font-weight: bold;
  letter-spacing: 3px;
  text-align: center;
}
.top-pc__live--under-line {
  border-bottom: solid;
  border-color: $color-accent;
  border-width: 5px;
  padding-bottom: 3px;
}
.top-pc__live--youtube {
  margin-top: 16px;
  border: solid;
  border-color: #F1FAEE;
  border-width: 5px;
  width: 100%;
  height: 450px;
}
.top-pc__live--youtube-attention {
  font-size: 1vw;
  text-align: right;
}
.top-pc__live--sub-title-text {
  font-size: 1.5vw;
  font-weight: bold;
  letter-spacing: 3px;
  text-align: center;
  margin-top: 24px;
}
.top-pc__live--checking-text {
  font-size: 1.8vw;
  font-weight: bold;
  padding: 8px 16px 8px 16px;
  background-color: #E63946;
  text-align: center;
}
.top-pc__live--tweet-button {
  font-size: 2vw;
  font-weight: 800;
  color: #F1FAEE;
}
.top-pc__live--tweet-description {
  font-size: 1.2vw;
  line-height: 2em;
  font-weight: bold;
}
.top-pc__live--tweet-attention {
  font-size: 0.8vw;
  line-height: 2em;
}
.top-pc__live--tweet-underline {
  border-bottom: solid;
  border-color: $color-accent;
  border-width: 3px;
  padding-bottom: 3px;
}
</style>
